module.exports = __webpack_public_path__ + "static/media/fj.caf72f69.svg";